import styled from 'styled-components';
import { xs } from '../../../../../BreakPoints';

export const TopBar = styled.div`
	height: 56px;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 0.45rem 1rem;
	justify-content: space-between;
	gap: 0.65rem;
	background: rgba(26, 35, 64, 0.3);
	backdrop-filter: blur(5px);
	border-bottom: 1px solid rgba(255, 255, 255, 0.28);

	${xs({
		padding: '0.4rem 0.6rem',
		gap: '0.35rem',
	})}
`;

export const LeftWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	min-width: 0;
	align-items: center;
	justify-content: flex-start;
	height: 100%;
	gap: 0.65rem;
`;
export const RightWrapper = styled.div`
	display: flex;
	flex: 0;
	height: 100%;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
`;

export const InviteButton = styled.button`
	display: flex;
	border: none;
	height: 2rem;
	color: white;
	padding: 0rem 0.85rem;
	align-items: center;
	gap: 0.4rem;
	border-radius: 6px;
	background-color: rgba(59, 99, 247, 0.95);
	cursor: pointer;
	transition: 250ms ease;
	&:hover {
		background-color: rgba(47, 86, 220, 0.95);
	}
`;

export const TextSpan = styled.span`
	font-size: 0.85rem;
	font-weight: 600;
	${xs({
		display: 'none',
	})}
`;

export const BoardNameInput = styled.input`
	height: 2rem;
	background-color: rgba(255, 255, 255, 0.28);
	border: none;
	border-radius: 6px;
	font-size: 1rem;
	text-align: left;
	padding: 0 0.6rem;
	min-width: 7rem;
	max-width: 12rem;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	width: ${(props) => props.value.length * 0.72 + 2.2 + 'rem'};
	font-weight: 600;
	color: white;
	outline: 1px solid rgba(255, 255, 255, 0.34);
	transition: 250ms ease;
	cursor: pointer;
	&:focus {
		background-color: white;
		outline: 2px solid var(--brand-blue);
		color: var(--deep-navy);
		cursor: text;
	}
	&:focus:hover {
		background-color: white;
		outline: 2px solid var(--brand-blue);
		color: var(--deep-navy);
		cursor: text;
	}
	&:hover {
		background-color: rgba(255, 255, 255, 0.42);
		outline: 1px solid rgba(255, 255, 255, 0.52);
	}
	&::placeholder {
		color: rgba(255, 255, 255, 0.88);
	}

	${xs({
		maxWidth: '8.5rem',
	})}
`;
